(() => {
  'use strict';

  if (window.__showgiftSearchDisplayGuardV1) return;
  window.__showgiftSearchDisplayGuardV1 = true;

  window.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    let action;
    try {
      action = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
    } catch (_) {
      return;
    }

    if (!action.pathname.endsWith('/search')) return;

    const visible = form.querySelector('input[type="search"][name="q"]');
    if (!(visible instanceof HTMLInputElement)) return;

    const original = String(visible.value || '').trim();
    if (!original) return;

    let proxy = form.querySelector('input[type="hidden"][data-sgp-search-q-proxy="1"]');
    if (!proxy) {
      proxy = document.createElement('input');
      proxy.type = 'hidden';
      proxy.dataset.sgpSearchQProxy = '1';
      form.insertBefore(proxy, visible);
    }

    proxy.name = 'q';
    proxy.value = original;

    visible.dataset.sgpOriginalSearchName = 'q';
    visible.removeAttribute('name');

    window.setTimeout(() => {
      if (!visible.isConnected) return;
      if (!visible.hasAttribute('name')) {
        visible.setAttribute('name', visible.dataset.sgpOriginalSearchName || 'q');
      }
      if (proxy.isConnected) proxy.remove();
    }, 1500);
  }, true);
})();
